<a (click)="routeMain()" (keydown.enter)="routeMain()" tabindex="0" class="navbar-brand">
  <div class="logo-main">
    <div class="logo-normal">
      <img ngSrc="{{ logo }}" alt="logo" height="30" width="30">
    </div>
    <div class="logo-mini">
      <img ngSrc="{{ logo }}" alt="logo" height="30" width="30">
    </div>
  </div>
  @if (isShowTitle()) {
    <h4 class="logo-title">{{ title }}</h4>
  }
  @if (isShowLogo()) {
    <acc-media [mediaId]="org?.logoId" class="logo-title ms-3" maxHeight="2rem" maxWidth="10rem"/>
  }
</a>
